import { useQuery } from '@tanstack/react-query'
import { fetchCandidateWithDetails, candidateKeys } from '@/services/candidates'

export function useCandidateWithDetails(id: string | undefined) {
  const candidateQuery = useQuery({
    queryKey: candidateKeys.detailWithDetails(id!),
    queryFn: () => fetchCandidateWithDetails(id!),
    enabled: !!id,
  })

  return {
    candidate: candidateQuery.data,
    isLoading: candidateQuery.isLoading,
    error: candidateQuery.error,
  }
}
